/**
 * MW STUFFS - Offer Slider
 * Auto-rotating offer carousel with dots, swipe, pause-on-hover.
 */
(function () {
  if (customElements.get('offer-slider')) return;

  class OfferSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayTimer = null;
      this.track = this.querySelector('[data-track]');
      this.dots = this.querySelectorAll('[data-dot-index]');
      this.slides = this.querySelectorAll('[data-slide-index]');
      this.slideCount = parseInt(this.dataset.slideCount, 10) || 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 4000;
      this.touchStartX = 0;
      this.touchEndX = 0;
    }

    connectedCallback() {
      if (this.slideCount <= 1) return; // no slider needed for 0-1 slides

      this.setupDots();
      this.setupSwipe();
      this.setupHoverPause();

      if (this.autoplay) {
        this.startAutoplay();
      }

      this.goTo(0);
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    setupDots() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.dotIndex, 10);
          this.goTo(idx);
          this.restartAutoplay();
        });
      });
    }

    setupSwipe() {
      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, { passive: true });
    }

    handleSwipe() {
      const diff = this.touchEndX - this.touchStartX;
      const threshold = 50;
      if (Math.abs(diff) < threshold) return;

      if (diff < 0) {
        // swipe left → next
        this.next();
      } else {
        // swipe right → prev
        this.prev();
      }
      this.restartAutoplay();
    }

    setupHoverPause() {
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });
    }

    goTo(index) {
      if (index < 0) index = this.slideCount - 1;
      if (index >= this.slideCount) index = 0;
      this.currentIndex = index;

      // Move track
      const offset = -index * 100;
      if (this.track) {
        this.track.style.transform = `translateX(${offset}%)`;
      }

      // Update dots
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.next(), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      if (this.autoplay) this.startAutoplay();
    }
  }

  customElements.define('offer-slider', OfferSlider);
})();